module.exports = __webpack_public_path__ + "static/media/Punk Rocker.fd3ad41f.jpg";